export default __webpack_public_path__ + "static/media/naturebible_logo.b0eb3fbb.png";